<template>
  <div class="background">
    <div class="card">
      <img src="../assets/back.png" alt="Return" class="return-icon" />
      <div class="title">Create your account 1/3</div>
      <div class="reminders">
        <div class="content">
          <img
            class="input"
            :src="select1 ? selectedPic : unSelectedPic"
            alt=""
            @click="select1 = !select1"
          />
          <span :class="!select1 ? '' : 'grey'">
            Do NoT share your password(Private Key) with ANYONE. Anyone with
            your password(Private Key) can have full control over yourassets.
            Please stay vigilant against phishing attacks at all times.
          </span>
        </div>
        <div class="content">
          <img
            class="input"
            :src="select2 ? selectedPic : unSelectedPic"
            alt=""
            @click="select2 = !select2"
          />
          <span :class="!select2 ? '' : 'grey'">
            Back up the password(Private Key). You will never be able to restore
            your account without your password(Private Key).
          </span>
        </div>
        <div class="content">
          <img
            class="input"
            :src="select3 ? selectedPic : unSelectedPic"
            alt=""
            @click="select3 = !select3"
          />
          <span :class="!select3 ? '' : 'grey'">
            Do NoT share your seed phrase with ANYONE. Anyone with your seed
            phrase can have full control over yourassets. Please stay vigilant
            against phishing attacks at all times.
          </span>
        </div>
        <div class="content">
          <img
            class="input"
            :src="select4 ? selectedPic : unSelectedPic"
            alt=""
            @click="select4 = !select4"
          />
          <span :class="!select4 ? '' : 'grey'">
            Back up the phrase safely. You will never be able to restore your
            account without your seed phrase.
          </span>
        </div>
      </div>
      <button
        :class="
          select1 && select2 && select3 && select4
            ? 'create-button'
            : 'create-button grey'
        "
        @click="jump()"
      >
        <span>Create</span>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      select1: false,
      select2: false,
      select3: false,
      select4: false,
      selectedPic: require("../assets/selected.png"),
      unSelectedPic: require("../assets/not-select.png"),
    };
  },
  methods: {
    jump() {
      if (this.select1 && this.select2 && this.select3 && this.select4) {
        this.$router.push({ name: "create-2" });
      }
    },
  },
};
</script>
<style>
html {
  /* width: 1920px;
    height: 937px; */
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  background: #006e54 !important;
  border-radius: 0px 0px 0px 0px;
}

.card {
  margin: calc(100 / 937 * 100vh) auto 0;
  position: relative;
  width: calc(556 / 1920 * 100vw);
  height: calc(774 / 937 * 100vh);
  background: #ffffff;
  border-radius: calc(28 / 1920 * 100vw);
}
@media (max-width: 600px) {
  .card {
    width: 90vw; /* 在小屏幕上，让卡片宽度更适应屏幕 */
    margin-top: 10vh; /* 调整边距 */
    border-radius: 10px; /* 调整边角半径 */
  }
  .return-icon {
    left: calc(10 / 90 * 100vw) !important;
    width: calc(5 / 90 * 100vw) !important;
    height: calc(5 / 90 * 100vw)  !important;
  }

  .reminders {
    left: calc(10 / 90 * 100vw) !important;
    top: calc(180 / 932 * 100vh) !important;
    width: calc(65 / 90 * 100vw) !important;
    height: calc(430 / 932 * 100vh);
    overflow-y: auto !important;
    overflow-x: hidden !important;

  }
  .title {
    left: calc(10 / 90 * 100vw) !important;
    font-size: 21px !important;
  }
  .content {
    line-height: 18px !important;
  }
  .content .input {
    width: calc(4 / 90 * 100vw) !important;
    height: calc(4 / 90 * 100vw) !important;
  }
  .content span {
    font-size: 16px !important;
    width: 60vw !important;
  }
  .create-button {
    /* bottom: 4vh !important; */
    left: calc(10 / 90 * 100vw) !important;
    width: calc(60 / 90 * 100vw) !important;
    height: calc(9 / 90 * 100vw) !important;
  }
  .create-button span {
    width: calc(50 / 90 * 100vw) !important;
    height: calc(20 / 90 * 100vw) !important;
    font-size: 18px !important;
    line-height: 18px !important;
  }
}

.return-icon {
  position: absolute;
  margin: 0;
  padding: 0;
  width: calc(28 / 1920 * 100vw);
  height: calc(28 / 1920 * 100vw);
  top: calc(80 / 937 * 100vh);
  left: calc(80 / 1920 * 100vw);
  background: #ffffff;
}

.reminders {
  position: absolute;
  top: calc(212 / 937 * 100vh);
  left: calc(80 / 1920 * 100vw);
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: calc(17 / 1920 * 100vw);
  color: #000000;
  line-height: calc(22 / 1920 * 100vw);
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.title {
  position: absolute;
  top: calc(144 / 937 * 100vh);
  left: calc(80 / 1920 * 100vw);
  font-family: Roboto-Bold;
  font-weight: bold;
  font-size: calc(26 / 1920 * 100vw);
  color: #000000;
  line-height: 0px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.content {
  display: flex;
  flex-wrap: nowrap;
  font-weight: 400;
  /* width: calc(600 / 1920 * 100vw); */
  color: #000000;
  line-height: calc(22 / 1920 * 100vw);
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.content .input {
  width: calc(28 / 1920 * 100vw);
  height: calc(28 / 1920 * 100vw);
}
.content span {
  padding: 0;
  font-family: Roboto-Regular;
  font-size: calc(17 / 1920 * 100vw);
  margin: 0 0 calc(24 / 937 * 100vh) calc(4 / 1920 * 100vw);
  width: calc(364 / 1920 * 100vw);
}
.create-button {
  position: absolute;
  bottom: calc(80 / 937 * 100vh);
  left: calc(75 / 1920 * 100vw);
  width: calc(396 / 1920 * 100vw);
  height: calc(40 / 1920 * 100vw);
  background: #028760;
  border-radius: 6px 6px 6px 6px;
  border: none;
}
.grey {
  opacity: 0.2;
}
.create-button span {
  width: calc(50 / 1920 * 100vw);
  height: calc(20 / 1920 * 100vw);
  font-family: Roboto, Roboto;
  font-weight: 500;
  font-size: calc(17 / 1920 * 100vw);
  color: #ffffff;
  line-height: 0px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
</style>
